import { defineAsyncComponent } from 'vue';

export { TeamReport } from './components/TeamReport';

export const teamReportMicroFrontends = {
	TeamReport: defineAsyncComponent(
		() => import('./components/TeamReport/TeamReport.vue')
	),
	TeamReportMetrics: defineAsyncComponent(
		() => import('./components/TeamReport/TeamReportMetrics.vue')
	),
};
